module.exports = __webpack_public_path__ + "static/image002-2f43449fb941cfbab253113d14e017f0.jpg";